import React from 'react'
import tw, {styled} from 'twin.macro'
import {motion} from 'framer-motion'
import ScrollAnimation from '../general/ScrollAnimation'
import {scale} from '../../utils/utils'

const Wrapper = tw.div`
  /* height: 75vh;
  width: 100%; */
`

const Container = tw.div`
 bottom-0 left-0 px-8 md:px-16 pb-8 md:pb-16 z-50
`

const Title = tw(motion.h1)`
text-4xl
font-bold z-10 pb-4`

const Date = tw(motion.h2)`
font-bold z-10 uppercase text-xs tracking-wide`

const Venue = tw(motion.h3)`text-base
font-bold z-10`

const BigText = (props) => {
  return (
    <Container>
      <Title
        initial={{opacity: 0, y: 20}}
        animate={{opacity: 1, y: 0}}
        transition={{delay: 1.3, ease: [0.22, 1, 0.36, 1], duration: 1.22}}
      >
        {props.title}
      </Title>
      <Date
        initial={{opacity: 0, y: 10}}
        animate={{opacity: 1, y: 0}}
        transition={{delay: 1.9, ease: [0.22, 1, 0.36, 1], duration: 1.22}}
      >
        {props.date}
      </Date>
      <Venue
        initial={{opacity: 0, y: 10}}
        animate={{opacity: 1, y: 0}}
        transition={{delay: 1.9, ease: [0.22, 1, 0.36, 1], duration: 1.22}}
      >
        {props.venue}
      </Venue>
    </Container>
  )
}

export default BigText
